class AutoAdd {
    constructor(saleType, options = {}) {
        this.saleType = saleType;
        this.options = options;
        this.listMode = options.listMode || 'single';
        this.priceRequired = options.priceRequired || 0;
        this.codeRequired = options.codeRequired || '';
        this.gWPProduct = options.gWPProduct || '';
        this.buyVariants = options.buyVariants || '';
        this.getVariants = options.getVariants || [this.gWPProduct] || [];
        this.formatVariantStrings();
        this.quantity = options.quantity || '';
        this.cartItemsIds = [];
        window.AutoAddsafeGuardCount = window.AutoAddsafeGuardCount || 0;
        this.init();
    }

    formatVariantStrings() {
        if (!this.buyVariants || !this.getVariants) return;

        if (this.listMode === 'single') {
            this.buyVariants = this.buyVariants.split(',').map(string => string.trim());
            this.getVariants = this.getVariants.split(',').map(string => string.trim());
        } else if (this.listMode === 'dual') {
            // Handle formatting for dual listMode
            this.buyVariants = this.buyVariants.map(list => list.split(',').map(string => string.trim()));
            this.getVariants = this.getVariants.split(',').map(string => string.trim());
        }
    }

    checkIfVariantInCart() {
        const cartItemElements = Array.from(document.querySelectorAll('cart-drawer-items [data-variant-id]'))
        this.cartItemsIds = cartItemElements.map(element => element.dataset.variantId)

        if (this.listMode === 'single') {
            return this.cartItemsIds.find(id => this.buyVariants.includes(id))
        } else if (this.listMode === 'dual') {
            // Assuming buyVariants is an array of arrays where each sub-array is a list of variants
            const list1 = this.buyVariants[0];
            const list2 = this.buyVariants[1];

            const isInList1 = this.cartItemsIds.some(id => list1.includes(id));
            const isInList2 = this.cartItemsIds.some(id => list2.includes(id));

            return isInList1 && isInList2;
        }
    }

    async getCartPriceInCents() {
        try {
            const cart = await getCart();
            const { total_price } = cart || {};
            return total_price;
        } catch (error) {
            console.log(error);
            // BEGIN_BUG_TRACKING_REMOVE - Comment for easy removal using regex
            publish(PUB_SUB_EVENTS.cartError, { source: 'auto-add', action: 'create', error, context: {
                note: this.saleType  === 'Classic' ? 'Classic Auto Add failed inside getCartPriceInCents' : 'GWP Auto Add failed inside getCartPriceInCents'
            }});
            // END_REMOVE
            return null;
        }
    }

    generateProductProperty() {
        if (this.listMode === 'single') {
            return {
                "_buy-variant-ids": this.buyVariants.join(',')
            }
        } else if (this.listMode === 'dual') {
            const list1 = this.buyVariants[0];
            const list2 = this.buyVariants[1];
            return {
                "_buy-a-get-b-variant_list_1-ids": list1.join(','),
                "_buy-a-get-b-variant-list_2-ids": list2.join(','),
            }
        }  else if (this.listMode === 'tieredPrice') {
            return {
                "_requiredPrice": this.priceRequired
            }
        }

    }

    async AddAutoGiftToCart() {
        switch (this.saleType) {
            case 'Classic':
                this.addAutoGiftClassic();
                break;
            case 'GWP':
                this.addAutoGiftGWP();
                break;
            default:
                console.log('Unsupported saleType:', this.saleType);
                break;
        }
    }

    addAutoGiftClassic() {
        const variant = this.checkIfVariantInCart();
        const addGiftOrNot = variant && !this.checkIfAlreadyAddedToCart();
        if (addGiftOrNot) {
            this.incrementAutoAddsafeGuardCount();
            if (window.AutoAddsafeGuardCount > 10) return;
            const productProperties = this.generateProductProperty();
            const items = this.getVariants.map((id) => ({
                quantity: 1,
                id,
                properties: productProperties
            }));

            this.addToCartAndLog(items);
        }
    }

    async addAutoGiftGWP() {
        try {
            const priceInCents = await this.getCartPriceInCents();
            const priceRequired = this.priceRequired ? parseInt(this.priceRequired) : 0;
            const addGiftOrNot = ( priceInCents > priceRequired) && !this.checkIfAlreadyAddedToCart()
            
            if(this.codeRequired && this.codeRequired !== this.getCookie('tierSaleCookie')){
                console.log('Code protection failed.');
                return;
            } else {
                if (addGiftOrNot) {
                    this.incrementAutoAddsafeGuardCount();
                    if (window.AutoAddsafeGuardCount > 10) return;
                    const productProperties = this.generateProductProperty();
                    const items = [{
                        quantity: 1,
                        id: this.gWPProduct,
                        properties: productProperties
                    }];
                    this.addToCartAndLog(items);
                }
            }
        } catch (error) {
            console.log(error);
            // BEGIN_BUG_TRACKING_REMOVE - Comment for easy removal using regex
            publish(PUB_SUB_EVENTS.cartError, { source: 'auto-add', action: 'create', error, context: {
                note: this.saleType === 'GWP' ? 'GWP Auto Add failed inside addAutoGiftGWP' : 'Classic Auto Add failed inside addAutoGiftGWP'
            }});
            // END_REMOVE
        }
     
    }

    getCookie(name) {
      var value = "; " + document.cookie;
      var parts = value.split("; " + name + "=");
      if (parts.length == 2) return parts.pop().split(";").shift();
      return null;
    }

    incrementAutoAddsafeGuardCount() {
        window.AutoAddsafeGuardCount = window.AutoAddsafeGuardCount || 0;
        window.AutoAddsafeGuardCount += 1;
    }

    async addToCartAndLog(items) {
        try {
            const result = await addMultipleToCart(items);
            const resultItems = result?.items || [];
            resultItems.forEach(resultItem => {

                publish(PUB_SUB_EVENTS.cartUpdate, { source: 'auto-add', productVariantId: resultItem.variant_id });
                this.logToLocalStorage(resultItem.variant_id);
            });
        } catch (error) {
            console.log(error);
            // BEGIN_BUG_TRACKING_REMOVE - Comment for easy removal using regex
            publish(PUB_SUB_EVENTS.cartError, { source: 'auto-add', action: 'create', error, context: {
                note: this.saleType === 'Classic' ? 'Classic Auto Add failed inside addToCartAndLog' : 'GWP Auto Add failed inside addToCartAndLog'
            }});
            // END_REMOVE
        }
    }

    checkIfAlreadyAddedToCart() {
        const log = localStorage.getItem("freeGiftLog");
        if (!log) return false;

        const logArray = JSON.parse(log).map(id => id.toString());

        const isInLocalStorage = this.getVariants.some(getVariantId => logArray.includes(getVariantId));

        return isInLocalStorage
    }
    

    logToLocalStorage(id) {
        let log = localStorage.getItem("freeGiftLog");

        let logArray;
        if (!log) {
            logArray = [];
        } else {
            logArray = JSON.parse(log);
        }

        if (!logArray.includes(id)) {
            logArray.push(id);
        }

        localStorage.setItem("freeGiftLog", JSON.stringify(logArray));
    }

    init() {
        this.AddAutoGiftToCart()
    }
}